export type IxisEventType =
  | 'next_clicked'
  | 'previous_clicked'
  | 'cta_clicked'
  | 'disclaimer_viewed';

export type IxisDataAttributes = Pick<
  IxisEventData,
  'bannerHeadline' | 'slideTitle' | 'ctaText' | 'ctaLink' | 'altText' | 'position'
>;

export type IxisNavigationAttributes = Pick<IxisEventData, 'position' | 'label'>;

const cloneEvent = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj)) as T;
};

export const generateIxisDataAttributes = (
  ixisDataAttributes: IxisDataAttributes,
): Record<string, string> => {
  const attributes = {
    'nar-feature-app-id': __FEATURE_APP_NAME__,
    'nar-feature-app-base-url': typeof window !== 'undefined' ? window.location.origin : '',
    'nar-tracking-banner-headline': ixisDataAttributes.bannerHeadline || '',
    'nar-tracking-slide-title': ixisDataAttributes.slideTitle || '',
    'nar-tracking-cta-text': ixisDataAttributes.ctaText || '',
    'nar-tracking-cta-link': ixisDataAttributes.ctaLink || '',
    'nar-tracking-image-alt': ixisDataAttributes.altText || '',
    'nar-tracking-position': String(ixisDataAttributes.position),
  };

  return Object.fromEntries(Object.entries(attributes).filter(([, value]) => value !== ''));
};

export const generateNavigationTrackingAttributes = (
  ixisNavigationAttributes: IxisNavigationAttributes,
): Record<string, string> => {
  const attributes = {
    'nar-tracking-position': String(ixisNavigationAttributes.position),
    'nar-tracking-label': ixisNavigationAttributes.label || '',
  };

  return Object.fromEntries(Object.entries(attributes).filter(([, value]) => value !== ''));
};

export const trackEvent = (
  eventData: Omit<IxisEventData, 'featureAppId' | 'featureAppBaseUrl'>,
): void => {
  if (typeof window === 'undefined') return;

  if (!Array.isArray(window.ixisEventData)) {
    window.ixisEventData = [];
  }

  const featureAppBaseUrl = typeof window !== 'undefined' ? window.location.origin : '';

  const event: IxisEventData = {
    featureAppId: __FEATURE_APP_NAME__,
    featureAppBaseUrl: featureAppBaseUrl,
    ...eventData,
  };
  const clonedEvent = cloneEvent(event);
  window.ixisEventData.push(clonedEvent);
};
